import { createClient, type SupabaseClient } from "@supabase/supabase-js";

/* Tek singleton Supabase client. Env konfigürasyonu yoksa null döner;
   çağıran taraf tracking'i sessizce devre dışı bırakır (demo UX'i asla kilitlenmez). */
let client: SupabaseClient | null = null;

export function getSupabaseClient(): SupabaseClient | null {
  if (client) return client;

  const url = import.meta.env.VITE_PUBLIC_SUPABASE_URL as string | undefined;
  const anonKey = import.meta.env.VITE_PUBLIC_SUPABASE_ANON_KEY as string | undefined;

  if (!url || !anonKey) return null;

  client = createClient(url, anonKey, {
    auth: { persistSession: false, autoRefreshToken: false },
  });

  return client;
}